export const version = "wallet/5.6.1";
//# sourceMappingURL=_version.js.map